import React from "react";
import PropTypes from "prop-types"; // PropTypes for type checking
import { Box, Grid, TextField } from "@material-ui/core"; // Material-UI components for layout and input
import Autocomplete from "@material-ui/lab/Autocomplete"; // Autocomplete component for suggestions
import parse from "autosuggest-highlight/parse"; // Utility to parse highlighted text
import match from "autosuggest-highlight/match"; // Utility to match highlighted text
import { getEmailData } from "Redux/Actions/merchantInformation"; // Redux action to fetch email data
import { useDispatch } from "react-redux"; // Redux dispatch hook

const EmailAutofillManager = ({
  email, // Current email value
  onEmailChange, // Function to handle email input changes
  agentsList, // List of agents for autocomplete suggestions
  setSelectedUser, // Function to set the selected user
  allowManualInput, // Boolean to allow manual input
  emailError, // Boolean to indicate email validation error
  values, // Additional form values
  buttonFlag, // Boolean to disable input based on conditions
}) => {
  const dispatch = useDispatch(); // Initialize Redux dispatch

  // Handle input change for the email field
  const handleInputChange = event => {
    const { value } = event.target;
    onEmailChange(value.toLowerCase()); // Convert email to lowercase
    setSelectedUser(null); // Reset selected user
  };

  return (
    <Box>
      <Grid container>
        <Grid item xs={12}>
          {/* Autocomplete component for email suggestions */}
          <Autocomplete
            style={{ fontSize: "14px" }} // Custom font size
            value={email} // Current email value
            autoHighlight // Highlight matching text in suggestions
            disabled={buttonFlag === true} // Disable input if buttonFlag is true
            fullWidth // Full width input
            name="agentId"
            id="agentId"
            onInputChange={(e, newInputValue) => {
              onEmailChange(newInputValue.toLowerCase()); // Update email value
              setSelectedUser(null); // Reset selected user
            }}
            onChange={(_, value) => {
              setSelectedUser(value); // Set selected user
              if (value) {
                dispatch(getEmailData(value)); // Fetch email data for the selected user
              } else {
                onEmailChange(""); // Reset email value
                setSelectedUser(null); // Reset selected user
              }
            }}
            options={agentsList} // List of suggestions
            getOptionLabel={option => option} // Display option as is
            renderInput={params => (
              <TextField
                {...params}
                label="Email" // Input label
                value={email || ""} // Current email value
                style={{ width: "100%" }} // Full width styling
                onChange={handleInputChange} // Handle input change
                disabled={buttonFlag === true} // Disable input if buttonFlag is true
                required // Mark input as required
                error={emailError} // Indicate validation error
                helperText={emailError ? "Invalid email" : ""} // Display error message
                variant="outlined" // Outlined input style
                InputProps={{
                  ...params.InputProps,
                  style: {
                    backgroundColor: !values.businessType ? "white" : "inherit", // Adjust background color based on businessType
                  },
                }}
              />
            )}
            renderOption={(option, { inputValue }) => {
              const matches = match(option, inputValue); // Match input value with option
              const parts = parse(option, matches); // Parse matched parts for highlighting
              return (
                <div>
                  {parts.map((part, index) => (
                    <span
                      key={index}
                      style={{
                        backgroundColor: part.highlight ? "#f3ff0070" : "", // Highlight matched text
                        fontWeight: part.highlight ? 400 : "", // Adjust font weight for highlighted text
                        fontSize: "14px", // Custom font size
                      }}
                    >
                      {part.text}
                    </span>
                  ))}
                </div>
              );
            }}
            freeSolo={allowManualInput} // Allow manual input if specified
          />
        </Grid>
      </Grid>
    </Box>
  );
};

// Define prop types for the component
EmailAutofillManager.propTypes = {
  email: PropTypes.string.isRequired, // Current email value
  onEmailChange: PropTypes.func.isRequired, // Function to handle email input changes
  agentsList: PropTypes.array.isRequired, // List of agents for autocomplete suggestions
  selectedUser: PropTypes.any, // Currently selected user
  setSelectedUser: PropTypes.func.isRequired, // Function to set the selected user
  allowManualInput: PropTypes.bool, // Boolean to allow manual input
  getEmailData: PropTypes.func, // Redux action to fetch email data
  emailError: PropTypes.bool, // Boolean to indicate email validation error
  values: PropTypes.object.isRequired, // Additional form values
  buttonFlag: PropTypes.bool, // Boolean to disable input based on conditions
};

// Export the component
export default EmailAutofillManager;
